import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Background from "../../image/bg3.jpg";
import Sustainable from "../../image/sustainable.jpg"
import Traditional from "../../image/traditionalknowledge.jpg"
import Discover from "../../image/selfdiscovery.jpg"

export default function Roverview() {
    return(
        <><Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
            <Container>
                <Row className="justify-content-center section">
                    <Col md="8" className="image-over-section">
                    <p style={{fontSize:"1.12em"}}>Dr. Chariar's current work integrates the principles of sustainable design with the traditional knowledge available with the indigenous communities.
                    <br/> <br/>He focuses on how these principles manifest in the housing and sanitation space. He has worked with the Ministry of Rural Development to launch the Rural Housing Knowledge Network. In the field of Ecological Sanitation, he is one of the co-inventors of <a href="http://ekameco.com/zerodor-waterless-urinals" target="_blank" >Zerodor <i className="bi bi-box-arrow-up-right"></i></a>, a waterless urinal solution being used by more than 500 organizations in India and Africa.
                    </p></Col>
                </Row>
            </Container>
        </Container>
        
        <Container>
            <Row className="section">
            <h2 style={{textAlign:"center"}}> Domains of Research</h2>
            <Col md="4" sm="12">
            <Card>
            <Card.Img variant="top" src={Sustainable} />
            <Card.Body>
                <Card.Title>Design for Sustainability</Card.Title>
                <Card.Text>
                He has implemented innovative projects and developed new technologies that deeply embody the values of empathy, inclusion and sustainability. He has taken the entrepreneurial route to create impact in the water and sanitation space by launching an IIT Delhi partnered venture <a href="http://www.ekameco.com/" target="_blank">Ekam Eco Solutions <i className="bi bi-box-arrow-up-right"></i></a>.
                </Card.Text>
                <Button href="./sustainability">Read More <i className="bi bi-arrow-right"></i></Button>
            </Card.Body>
            </Card>
            </Col>

            <Col md="4" sm="12">
            <Card>
            <Card.Img variant="top" src={Traditional} />
            <Card.Body>
                <Card.Title>Traditional Knowledge</Card.Title>
                <Card.Text>
                He takes inspiration from the artisans, forest dwellers, farmers & grandmothers. He works with them to co-create contemporary solutions based on the rich traditional ecological knowledge. He offers immersive and experiential courses on eco-centric technologies and universal values.
                </Card.Text>
                <Button href="./traditional">Read More <i className="bi bi-arrow-right"></i></Button>
            </Card.Body>
            </Card>
            </Col>

            <Col md="4" sm="12">
            <Card>
            <Card.Img variant="top" src={Discover} />
            <Card.Body>
                <Card.Title>Self Discovery</Card.Title>
                <Card.Text>
                He offers courses and retreats that enable an experience of integration and fulfilment. His initiative <a href="http://www.joyisyou.com/" target="_blank">JoyIsYou <i className="bi bi-box-arrow-up-right"></i></a> supports the transformation of individuals and organizations towards achieving their highest potential. He also uses these principles to mentor his research students & young professionals.
                </Card.Text>
                <Button href="https://www.joyisyou.com" target="_blank">Read More <i className="bi bi-box-arrow-up-right"></i></Button>
            </Card.Body>
            </Card>
            </Col>

            </Row>

        </Container>
        </>
    )
}